// extracted by mini-css-extract-plugin
export default {"align":"TableQuestionnaire_align__MStPG","tg":"TableQuestionnaire_tg__sKBnU","scrollbar":"TableQuestionnaire_scrollbar__0BHKm"};